import { parseISO, isPast, addMinutes, formatDistance } from 'date-fns';
import { VIEWING_STATE } from '../../components/events/events.config.js';

export function getCurrentUser() {
    let user = null;

    let rx = new RegExp('^(?:.*;)*\\s*VCL\\.User\\s?=\\s?([^;]+)');
    let matches = decodeURIComponent(document.cookie).match(rx);
    if (matches && matches.length > 0) 
        user = JSON.parse(matches[1]);
    else
        user = JSON.parse(localStorage.getItem('VCL.User'));

    return user;
}

export function getAkamaiAuthToken() {
    let rx = new RegExp('^(?:.*;)*\\s*VCL\\.AkamaiAuth\\s?=\\s?([^;]+)');
    let matches = decodeURIComponent(document.cookie).match(rx);

    if (matches && matches.length > 0) {
        return matches[1];
    } else {
        return null;
    }
}

export function isLocallyReferred() {
    if (
        document.referrer !== undefined &&
        document.referrer !== null &&
        document.referrer.indexOf(document.location.origin) === 0
    ) {
        return true;
    } else {
        return false;
    }
}

export function isActive(event) {
    if (
        event.viewingState !== VIEWING_STATE.published &&
        event.viewingState !== VIEWING_STATE.ended &&
        event.viewingState !== VIEWING_STATE.endedredirect
    )
        return true;
    else return false;
}

export function getSignInUrl(useAadSignIn, returnUrl, accessKey, isEmbed) {
    if (returnUrl === undefined || returnUrl === null || returnUrl.length === 0)
        returnUrl = window.location.pathname + window.location.search;

    let signInUrl = '/account';
    if (useAadSignIn) {
        signInUrl += '/externalLogin?returnUrl=' + encodeURIComponent(returnUrl);
    } else {
        signInUrl += `/signin?eventAccessKey=${accessKey}&returnUrl=${encodeURIComponent(
            returnUrl
        )}`;
        if (isEmbed) signInUrl += '&embed';
    }

    return signInUrl;
}

export function getUserDisplayNameWithCompany(user) {
    if (user === null) return '';

    if (user._wk && user._wk.length > 0) return (user._dn += ' (' + user._wk + ')');

    return user._dn;
}

export function setUserLocation(headers) {
    if (headers.get('vcl-country') !== undefined)
        localStorage.setItem('vcl-country', headers.get('vcl-country'));

    if (headers.get('vcl-city') !== undefined)
        localStorage.setItem('vcl-city', headers.get('vcl-city'));

    if (headers.get('vcl-region') !== undefined)
        localStorage.setItem('vcl-region', headers.get('vcl-region'));

    if (headers.get('vcl-georegion') !== undefined)
        localStorage.setItem('vcl-georegion', headers.get('vcl-georegion'));

    if (headers.get('vcl-continent') !== undefined)
        localStorage.setItem('vcl-continent', headers.get('vcl-continent'));
}

export function isUserInChina() {
    let userLocation = localStorage.getItem('vcl-country');
    if (userLocation === undefined || userLocation === null) {
        return false;
    } else {
        return userLocation.toLowerCase() === 'cn';
    }
}

// Takes an ISO UTC string, for example '2021-01-07T14:10:03' and converts it to a DateTime object using the browser's locale.
export function getDateFromUTCString(dateString) {
    // If dateString is an object, it's probably a DateTime already and can be returned as is
    if (dateString && typeof dateString === 'object') {
        return dateString;
    } else if (typeof dateString === 'string') {
        // Add a 'Z' in the end if not already present before parsing
        if (!dateString || dateString.match(/z$/i)) {
            return parseISO(dateString);
        } else {
            return parseISO(dateString + 'Z');
        }
    } else {
        throw 'Incorrect type, please provide an ISO UTC datetime string or a DateTime object.';
    }
}

/*
 * this function will return time distance e.g. Min ago, Hours ago, x Days ago
 */
export function calculateDistanceFromTime(dateString) {
    return formatDistance(getDateFromUTCString(dateString), new Date(), { addSuffix: true });
}

export function parseDateToLocale(dateString) {
    return getDateFromUTCString(dateString).toLocaleDateString(navigator.language);
}

export function parseTimeToLocale(dateString) {
    var date = getDateFromUTCString(dateString);
    return date.toLocaleTimeString(navigator.language, {
        hour: '2-digit',
        minute: '2-digit'
    });
}

/*
 * this function will return date time in locale format e.g. 2021-07-26 12:00
 */
export function parseDateTimeToLocale(dateString) {
    if (dateString) {
        var date = getDateFromUTCString(dateString);
        return (
            date.toLocaleDateString(navigator.language) +
            ' ' +
            date.toLocaleTimeString(navigator.language, {
                hour: '2-digit',
                minute: '2-digit'
            })
        );
    } else {
        return null;
    }
}

/*
 * this function will return date at time in locale format e.g. 2021-07-26 at 12:00
 */
export function parseDateAtTimeToLocale(dateString) {
    var date = getDateFromUTCString(dateString);
    return (
        date.toLocaleDateString(navigator.language) +
        ' at ' +
        date.toLocaleTimeString(navigator.language, {
            hour: '2-digit',
            minute: '2-digit'
        })
    );
}

/**
 * severity: 1=Info, 2=Warning, 3=Error
 */
export function log(category, message, verboseOnly, severity, error) {
    if (!verboseOnly || (verboseOnly && siteSettings.verboseLogging)) {
        message = '[' + category + '] ' + message;
        if (error) {
            message = message + ' | ' + error.toString();
        }

        if (window.appInsights !== undefined && window.appInsights !== null) {
            window.appInsights.trackTrace({ message });
            if (severity === 3) {
                window.appInsights.trackException({
                    exception: error
                });
            }
        }

        if (severity === 1) console.info(message);
        else if (severity === 2) console.warn(message);
        else if (severity === 3) console.error(message);
    }
}

export function hideElement(el) {
    if (el !== undefined && el !== null && !el.classList.contains('hide')) el.classList.add('hide');
}

export function showElement(el) {
    if (el !== undefined && el !== null && el.classList.contains('hide'))
        el.classList.remove('hide');
}

export function getVideoElem() {
    let videoElem = document.querySelector('video');

    if (videoElem) {
        return videoElem;
    } else {
        return null;
    }
}
export function getVJSPlayer(videoJS) {
    // Video tag variables need to use 'var' to work properly
    var videoElem = getVideoElem();
    var vjsElem = document.getElementById('vjs-player');

    if (videoElem && vjsElem) {
        return videoJS('vjs-player');
    } else {
        return null;
    }
}

export function vodCurrentTimeKey(event) {
    return event.accessKey + '-vod-current-time';
}

export function replaceNewline(originalText, replaceWith) {
    return originalText.replace(/\n+/g, replaceWith);
}

export function hasEventStarted(event) {
    return (
        (event.viewingState !== VIEWING_STATE.ended &&
            event.viewingState !== VIEWING_STATE.endedredirect &&
            isPast(getDateFromUTCString(event.startTime))) ||
        (event.useCustomCDSwitchover &&
            event.customCDSwitchOverTime &&
            isPast(getDateFromUTCString(event.customCDSwitchOverTime)))
    );
}

export function isEventInFuture(event) {
    return (
        !isPast(getDateFromUTCString(event.startTime)) &&
        (!event.useCustomCDSwitchover ||
            (event.useCustomCDSwitchover &&
                event.customCDSwitchOverTime &&
                !isPast(getDateFromUTCString(event.customCDSwitchOverTime))))
    );
}

export function hasEventGracePeriodEnded(event) {
    return isPast(
        addMinutes(getDateFromUTCString(event.stopTime), siteSettings.webcastEndGracePeriodMinutes)
    );
}

export function GetViewEventRelativeUrl(event) {
    return `/events#!/view/${event.id}`;
}

export function GetQnARelativeUrl(event) {
    return `/qna-moderation/${event.accessKey}`;
}

export function GetAccessKeyFromPath(path) {
    var akMatch = path.match(/(?!=\/)(vcl[a-z0-9]{6})(?=$|\/)/im);

    if (akMatch && akMatch.length > 0) return akMatch[0];

    return null;
}

export function getVideoJSThemeName() {
    let themeName = 'vjs-theme-fantasy';

    if (siteSettings.currentOrgName === 'Polestar') {
        themeName = 'vjs-theme-polestar';
    }

    return themeName;
}

export function getHashCode(str) {
    var hash = 0,
        i,
        chr;
    if (str.length === 0) return hash;
    for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}
